<script setup lang="ts">
import type { ActiveFilterChip } from '~/utils/filter/chips'

const openFilter = defineModel('openFilter', { default: false })

const { searchKeyword, authors, numFound, selectedLegalArea } = useAuthorFilters()

const count = computed(() => {
  if (authors.value.length === 1) {
    return 'Viser 1 forfatter'
  }
  if (authors.value.length > 0 && authors.value.length !== numFound.value) {
    return `Viser ${authors.value.length} av ${numFound.value} forfattere`
  }
  if (authors.value.length > 1) {
    return `Viser ${numFound.value} forfattere`
  }
  return ''
})

const chips = computed<ActiveFilterChip[]>(() =>
  selectedLegalArea.value.map(option => ({
    key: `area:${option.value}`,
    label: option.label,
    remove: () => {
      selectedLegalArea.value = selectedLegalArea.value.filter(o => o.value !== option.value)
    },
  })),
)
</script>

<template>
  <FilterListHeader
    v-model:search="searchKeyword"
    v-model:open-filter="openFilter"
    breakpoint="lg"
    :count="count"
    search-id="author-search-compact"
    search-label="Filtrer på forfatter"
    search-placeholder="Søk etter forfatter"
    :chips="chips"
  >
    <AuthorMobileFilters v-model:open-filter="openFilter" />
  </FilterListHeader>
</template>